import './Page.scss';

const Page = props => <div {...props} className={"page " + props.className}>
    {props.children}
</div>;

export default Page;